<template>
	<slot />
</template>

<style lang="scss">
.placeholder-for-empty-style-tag {
	display: block;
}
</style>
